import * as React from 'react';
import {Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, useTheme} from "@mui/material";
import { MoreVert, Refresh } from '@mui/icons-material';
import {useContext} from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ProgressContext } from '../context/Progress';
import { getAnalytics, setUserId } from 'firebase/analytics';

function Submenu() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { lang } = useParams();
  const { t } = useTranslation();
  const analytics = getAnalytics();
  const user = JSON.parse(localStorage.getItem('userInfo'));
  const progress = useContext(ProgressContext);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  function onClickLoginLogout() {
    if (user) {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('userAnswers');
      setUserId(analytics, null);
    }
    navigate(`/${lang}/signin`);
  }
  function resetProgress() {
    progress.reset();
    navigate(0);
  }

  return (<div>
    <IconButton
      id="submenu-button"
      aria-controls={open ? 'submenu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleOpen}
      sx={{color: theme.palette.primary.contrastText}}
    >
      <MoreVert />
    </IconButton>
    <Menu
      id="submenu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      slotProps={{
        list: {
          'aria-labelledby': 'submenu-button',
        },
      }}
    >
      <MenuItem onClick={() => resetProgress()}>
        <ListItemIcon><Refresh /></ListItemIcon>
        <ListItemText>{t('core.resetProgress')}</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={onClickLoginLogout}>
        <ListItemIcon></ListItemIcon>
        <ListItemText>{user ? t('auth.signOut') : t('auth.signIn')}</ListItemText>
      </MenuItem>
      <MenuItem disabled={true}>
        <ListItemIcon></ListItemIcon>
        <ListItemText>Version {import.meta.env.VITE_VERSION}</ListItemText>
      </MenuItem>
    </Menu>
  </div>);
}
export default Submenu;
